import './ChapterItem.less';
import React, {useState, useEffect} from 'react';
import Icon from "../../../../../bootstrap/components/icon/Icon";
import LessonList from "../lesson-list/LessonList";
import __ from '../../../../i18n';


export default function ChapterItem({chapter, lessons, currentLessonId}) {

    const [expanded, setExpanded] = useState(lessons.some(t => t.id === currentLessonId));

    useEffect(() => {
        setExpanded(lessons.some(t => t.id === currentLessonId));
    }, [currentLessonId]);

    return <li className="chapter-item">
        <div className="inline" onClick={() => setExpanded(!expanded)}>
            {
                expanded
                ? <Icon name="angle-up"/>
                : <Icon name="angle-down"/>
            }
            <div className="chapter-name">{chapter.name}</div>
        </div>
        {
            expanded &&
            <LessonList
                lessons={lessons}
                currentLessonId={currentLessonId}
            />
        }
    </li>;
}
